import { Component } from '@angular/core';
import { ComponentSubHtmlBase } from '../component-sub-html-base/component-sub-html-base.component';

@Component({
  selector: 'app-component-sub-html-inner-template',
  templateUrl: './component-sub-html-inner-template.component.html',
  styleUrls: ['./component-sub-html-inner-template.component.scss']
})
export class ComponentSubHtmlInnerTemplateComponent extends ComponentSubHtmlBase {

}
